import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss"
import Button from '../../../../component/Button'
import CheckboxComponent from '../../../../component/CheckboxComponent'
import { Icons, Images } from '../../../../assets'
import { useDispatch } from 'react-redux'
import config from '../../../../service/env'
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice'

const QrCheckbox = (props) => {
    const { detailInfo, setQRSetupModal } = props
    const [selectedValue, setSelectedValue] = useState("QR ID")
    const [allChecked, setAllChecked] = useState(false)
    const dispatch = useDispatch();
    const { apiUrl } = config

    const checkboxHeader = [
        "QR ID",
        "QR Img",
        // ""
    ]

    const [checkboxContent, setCheckboxContent] = useState([])

    useEffect(() => {
        if (detailInfo?.length > 0) {
            const checkBoxItem = detailInfo.map(item => ({
                ...item,
                isChecked: false
            }));
            setCheckboxContent(checkBoxItem)
        }
    }, [detailInfo])

    // const handleChange = (e, index) => {
    //     const checked = e.target.checked
    //     setCheckboxContent((prevState) => (
    //         prevState.map((item, ind) => (
    //             index === ind ? { ...item, isChecked: checked } : item
    //         ))
    //     ))
    // }

    // const handleAllChange = (e) => {
    //     const checked = e.target.checked
    //     setAllChecked(!allChecked)
    //     setCheckboxContent((prevState) => (
    //         prevState.map((item) => (
    //             { ...item, isChecked: checked }
    //         ))
    //     ))

    // }

    const downloadIndividualQR = (items) => {       
        dispatch(saveLoadingState(true))
        window.open(`${apiUrl}/qrcode/download_qr?id=${items?.[0]?.qrParentId}`, "_blank")
        dispatch(saveLoadingState(false))
    }


    return (
        <>
            <div className={`${classes.qrCardWrapper} mb-4`}>
                <div className=' flex justify-between mb-'>
                    <p className={`${classes.informationHeader}`}>QR Quantities</p>
                    {/* {checkboxContent?.filter((x) => x?.isChecked)?.length > 0 ? */}
                        <Button text="Download QR code" smallBtn onClick={() => downloadIndividualQR(detailInfo)} />
                        {/* : null} */}
                </div>
                <div className='flex justify-between border-b border-solid border-[#D9D9D9]'>
                    {
                        checkboxHeader.map((it, index) => (
                            <div key={index} className={`${classes.checkboxHeader}`} style={{ width: index == 0 ? '200px' : '150px', textAlign: index == 0 ? 'left' : 'center' }}>{it}</div>
                        ))
                    }

                </div>
                <div className='flex-col' style={{height: '300px', overflow : 'auto'}}>
                    {
                        checkboxContent.map((item, index) => (
                            <div className='flex justify-between border-b border-solid border-[#D9D9D9]' key={index}>
                                {/* <CheckboxComponent checked={item.isChecked} onChange={(e) => handleChange(e, index)} /> */}
                                <div className={`flex items-center ${classes.checkboxContent} w-[200px]`}>{item.qrCodeId}</div>
                                <div className='w-[150px] flex items-center justify-center'>
                                    <img src={Icons.qrIcon} className={`py-2`} />
                                </div>
                                {/* <div className='w-[150px] flex items-center justify-center'>
                                    <img src={Images.actionCircle} className={`h-[22px]`} onClick={() => window.open(item?.qrImagePath, '_blank')} />
                                </div> */}
                            </div>
                        ))
                    }
                </div>

            </div>

        </>
    )
}

export default QrCheckbox